// eslint-disable-next-line import/prefer-default-export
export const CONTENT_REDUCER_KEY = 'content';
